export class FullReplyInput {
  public guid: string;
  public pdfFileRequired: boolean; // Determines wether we must generate a PDF from the document
  public documentFile: string; // The document file (created from a template).
  public documentformat: string; // The document format, the default value is RTF.
  public documentdescription: string; // The document description (Template description).
  public serviceProprietaireId?: number;
  typeEntrantSortant?: string;
  confidentiel?: boolean;
  natureId?: number;
  sourceId?: number;
  refExpediteur?: string;
  objet?: string;
  remarques?: string;
  dateDocument?: string;
  dateEcheance?: string;
  dateEntree?: string;
  classementId?: number;
  classeurId?: number;
  chemiseId?: number;
  referenceRecommande?: string;
  datePostale?: string;
  boiteArchive?: string;
  statutId?: number;
  AutoDistributionbUsers?: [];
  AutoDistributionServices?: [];
}
